import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import { pushDialog } from './dialogs-store';
import { GlobalDialogComponent as GlobalDialogComponentInternal } from './GlobalDialogComponent';
import { useDialogs as useDialogsInternal } from './useDialogs.hook';
import { ValidationResultDialog } from './ValidationResultDialog';
export const GlobalDialogComponent = GlobalDialogComponentInternal;
// Internal elements for alert/confirm pushed onto the stack
/**
 * Hook API: push dialogs to the stack.
 */
export const useDialogs = () => {
    const { alert, confirm, openCustomDialog } = useDialogsInternal();
    return { alert, confirm, openCustomDialog };
};
export const useValidationResultDialog = (errorDependencies, options) => {
    const allItems = useMemo(() => {
        const result = [];
        for (const entry of (errorDependencies ?? [])) {
            const item = entry?.error ?? entry;
            if (Array.isArray(item?.items)) {
                for (const it of item.items) {
                    result.push({ type: it.type, message: it.message, path: it.path, label: it.label });
                }
            }
            else if (item?.message) {
                result.push({ type: item.type ?? 'error', message: item.message });
            }
        }
        return result;
    }, [errorDependencies]);
    const signature = useMemo(() => {
        try {
            return JSON.stringify(allItems.map(x => ({ t: x.type, m: x.message, p: x.path, l: x.label })));
        }
        catch {
            return String(allItems.length);
        }
    }, [allItems]);
    // Keep one dialog instance ref (no re-render on changes)
    const closeRef = useRef(null);
    useEffect(() => {
        // Push field errors into RHF control if provided
        if (options?.control) {
            for (const errorItem of allItems) {
                if (errorItem.path) {
                    options.control.setError(errorItem.path, {
                        type: 'server',
                        message: errorItem.message
                    });
                }
            }
        }
        const hasErrors = allItems.some(x => x.type === 'error');
        const hasWarnings = allItems.some(x => x.type === 'warning');
        if (allItems.length === 0) {
            // Close if open
            if (closeRef.current) {
                closeRef.current();
                closeRef.current = null;
            }
            return;
        }
        const render = (onClose) => (_jsx(ValidationResultDialog, { items: allItems, labels: options?.labels, onClose: onClose, onAcceptWarnings: hasWarnings && !hasErrors && options?.onAcceptWarnings ? options.onAcceptWarnings : undefined }));
        if (closeRef.current?.update) {
            closeRef.current.update(render(() => closeRef.current?.()));
        }
        else {
            const { close, update } = pushDialog(render(() => close()));
            closeRef.current = Object.assign(() => close(), { update });
        }
    }, [signature, options?.control]);
    return {};
};
//# sourceMappingURL=dialogs.js.map